import type { MenuProps, MenuState } from "@fluentui/react-components";
import {
  useMenu_unstable,
  toMountNodeProps,
  mergeClasses,
} from "@fluentui/react-components";
import { useMenuStyles } from "./useAppMenuStyles";

export const useAppMenu = (props: MenuProps): MenuState => {
  const styles = useMenuStyles();
  const mountNodeProps = toMountNodeProps(props.mountNode);
  mountNodeProps.className = mergeClasses(
    styles.portal,
    mountNodeProps.className
  );

  const state = useMenu_unstable({ ...props, mountNode: mountNodeProps });

  return state;
};
